export const CURRENT_WORKSHOP = "Mindsets";